import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Updates.css"; // Import styles
import Podium from "./Podium";
const Updates = () => {
    const [updates, setUpdates] = useState([]); // Store updates from backend
    const [loading, setLoading] = useState(true); // Track loading state
    const [error, setError] = useState(null); // Track any errors
    const [openUpdateId, setOpenUpdateId] = useState(null); // Track open update

    // Fetch updates from the backend
    useEffect(() => {
        const fetchUpdates = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND}/update/`);
                setUpdates(response.data.updates); // Set updates from response
            } catch (err) {
                setError("Failed to load updates. Please try again later.");
            } finally {
                setLoading(false); // Update loading state
            }
        };
        fetchUpdates();
    }, []);

    // Toggle the visibility of an update
    const toggleUpdate = (id) => {
        setOpenUpdateId((prevId) => (prevId === id ? null : id));
    };

    if (loading) {
        return <div className="updates-page">Loading updates...</div>;
    }

    if (error) {
        return <div className="updates-page error">{error}</div>;
    }

    return (
        <div className="updates-page">
            
            <header className="header">
                <h1>Updates</h1>
            </header>

            <main className="accordion">
                {updates?.length > 0 ? (
                    updates?.map((update) => (
                        <div key={update._id} className="accordion-item">
                            {/* Title */}
                            <button
                                className={`accordion-header ${
                                    openUpdateId === update._id ? "active" : ""
                                }`}
                                onClick={() => toggleUpdate(update._id)}
                                aria-expanded={openUpdateId === update._id}
                            >
                                <span className="toggle-icon">
                                    {openUpdateId === update._id ? "−  " : "+  "}
                                    {update.title}
                                </span>
                                <p className="timestamp">
                                    Posted on: {new Date(update.timestamp).toLocaleString()}
                                </p>
                            </button>

                            {/* Collapsible Content */}
                            <div
                                className={`accordion-content ${
                                    openUpdateId === update._id ? "show" : ""
                                }`}
                            >
                                <p>{update.message}</p>
                                {update.steps.length > 0 && (
                                    <>
                                        <h3>Steps:</h3>
                                        <ol>
                                            {update.steps.map((step, index) => (
                                                <li key={index}>{step}</li>
                                            ))}
                                        </ol>
                                    </>
                                )}
                                <p className="footer-text">{update.footer}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No updates available at this time.</p>
                )}
            </main>
        </div>
    );
};

export default Updates;
